import { render, staticRenderFns } from "./RelocationLimitForm.vue?vue&type=template&id=220db707&"
import script from "./RelocationLimitForm.vue?vue&type=script&lang=ts&"
export * from "./RelocationLimitForm.vue?vue&type=script&lang=ts&"
import style0 from "./RelocationLimitForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports